import { createAccStudents, fetchAllStudents } from "../../apis/studentApi"
import {
  requestPending,
  studentFechSuccess,
  requestFail,
  getSelectedStudent,
  studentAccountSuccess,
} from "./studentSlice"
import { toast } from "react-toastify"

export const createStudentAccountAction = (enrolment) => async (dispatch) => {
  dispatch(requestPending())
  const data = await createAccStudents(enrolment)
  data.status === "success"
    ? dispatch(studentAccountSuccess(data.user)) &&
      toast.success("Student account has been created!")
    : dispatch(requestFail()) && toast.error(data.message)
}

export const fetchStudentAction = () => async (dispatch) => {
  dispatch(requestPending())
  const data = await fetchAllStudents()

  data.status === "success"
    ? dispatch(studentFechSuccess(data))
    : dispatch(requestFail(data))
}

export const fetchSingleStudentAction = (_id) => async (dispatch) => {
  if (!_id) return

  dispatch(requestPending())

  const result = await fetchAllStudents(_id)

  result.status === "success"
    ? dispatch(getSelectedStudent(result.student))
    : dispatch(requestFail(result)) && toast.error(result.message)
}
